import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authClient } from "./defaults";
import styles from '../common.module.css'

const Authenticate = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [redirectTo, setRedirectTo] = useState("");

    const closePopup = () => {
        setShowPopup(false);
        setPopupMessage("");
        if (redirectTo) {
            navigate(redirectTo, { replace: true });
        }
    };

    useEffect(() => {
        const authenticateUser = async () => {
            const token = searchParams.get("token");

            if (!token) {
                setPopupMessage("Authentication token is missing.");
                setShowPopup(true);
                navigate("/login-signup");
                return;
            }

            if (isAuthenticating) return;

            setIsAuthenticating(true);

            try {
                const { data } = await authClient.post("/authenticate", { token });

                if (data.existingUser) {
                    if (data.consent) {
                        navigate("/dashboard", { replace: true });
                    } else {
                        navigate("/user-agreement", { replace: true });
                    }
                } else {
                    navigate("/register", { replace: true });
                }
            } catch (error) {
                console.error("Authentication error:", error);
                const errorMessage =
                    error.response?.data?.message || "Authentication failed. Please try again.";
                setPopupMessage(errorMessage);
                setShowPopup(true);
                setRedirectTo("/login-signup");
            } finally {
                setIsAuthenticating(false);
            }
        };

        authenticateUser();
    }, [navigate, searchParams]);

    return (
        <div>
            Authenticating... Please wait.
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>Error</h3>
                        <p>{popupMessage}</p>
                        <button onClick={closePopup} className="popup-close-button">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>);
};

export default Authenticate;
